module.exports = __webpack_public_path__ + "img/bind-success.3a27cb04.png";